import { getNestedProperty } from '@opallabs/lambda'
import { Stage, StageCollection, State, StateKeys } from '../../../../types'

type GetStages = (state: State) => StageCollection | undefined

type GetStage = (state: State, props: { id: string }) => Stage | undefined

type GetStagesByWorkflowId = (state: State, id: string) => Stage[] | undefined

export const getStages: GetStages = (state) =>
  getNestedProperty<StageCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.stage
  )

export const getStage: GetStage = (state, props) => {
  const stages = getStages(state)
  if (stages !== undefined) {
    return stages[props.id]
  }
  return undefined
}

export const getStagesByWorkflowId: GetStagesByWorkflowId = (state, id) => {
  const stages = getStages(state)
  if (stages !== undefined) {
    return Object.values(stages).filter(
      (stage) =>
        getNestedProperty<string>(stage, 'relationships', 'workflow', 'id') ===
        id
    )
  }
  return undefined
}
